import * as React from 'react'

import { createContext } from '~logic/lib/react'
import { useDrawer } from '~ui/components/content/Drawer/useDrawer'

type TContextValue = ReturnType<typeof useDrawer>

const [
  Provider, //
  useCartModalControlsCtx,
] = createContext<TContextValue>(`CartModalControls`)

type TProps = RequiredChildren

/**
 * Provider for menu modal cart controls, such as opening & closing the drawer
 */
export const CartModalControlsProvider: React.FC<TProps> = ({ children }) => {
  const controls = useDrawer()

  return <Provider value={controls}>{children}</Provider>
}

export { useCartModalControlsCtx }
